import { borderStroke as borderStrokeTokensThemed } from '@orus.eu/design-tokens/tokens/border-stroke-tokens.json'

type BorderStrokeTokensKeys = 10 | 20 | 30 | 40

export const borderStroke = Object.keys(borderStrokeTokensThemed.light).reduce(
  (styles, tokenName) => ({
    ...styles,
    [tokenName.replace('border-stroke-', '')]: `var(--${tokenName})`,
  }),
  {} as Record<BorderStrokeTokensKeys, string>,
)
